/* UX-048 — bottom bar for phones and tablets (snippets/hk-bottom-nav.liquid, < 990 px).
   Catalog and Suplimentar open the header drawer (snippets/header-drawer.liquid) through the drawer's own <summary>,
   so Dawn's MenuDrawer still does the opening, closing, focus trap and scroll lock; the bar only picks the tab and
   mirrors the state (aria-expanded). Tapping the open item again closes the drawer, or, while a sub-list is open,
   goes back to the top list (UX-049). Each item shows its own section: the drawer's tabs give way to a title.
   Contact opens a small sheet (sales · WhatsApp · service · parts · showroom) with today's hours from the top bar's
   schedule (HKTopbar.status(), ARCH-032). Taps on its links go to GTM as hk_contact_click, like the PDP contact row.
   The bar hides while a text field has focus and while a cart drawer, filter drawer or modal owns the screen. */
(function () {
  var bar = document.querySelector('[data-hk-bnav]');
  if (!bar || bar.__hkBnav) return;
  bar.__hkBnav = true;

  var mq = window.matchMedia('(max-width: 989px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var sheet = document.querySelector('[data-hk-bnav-sheet]');
  var panel = sheet && sheet.querySelector('.hk-bnav-sheet__panel');
  var hours = sheet && sheet.querySelector('[data-hk-bnav-hours]');
  var dot = bar.querySelector('[data-hk-bnav-dot]');
  var dotText = bar.querySelector('[data-hk-bnav-dot-text]');
  var items = {};
  bar.querySelectorAll('[data-hk-bnav-item]').forEach(function (el) {
    items[el.getAttribute('data-hk-bnav-item')] = el;
  });

  var details = document.getElementById('Details-menu-drawer-container');
  var drawer = details && details.closest('header-drawer');
  var summary = details && details.querySelector(':scope > summary');
  var opener = null; // the bar item that opened the drawer; focus goes back to it when the drawer closes
  var sheetOpen = false;
  var typing = false;
  // body classes Dawn sets for the cart drawer, search and other modals (overflow-hidden) and the filter drawer
  // (overflow-hidden-mobile); overflow-hidden-tablet is the header drawer itself, which the bar sits on top of
  var OVERLAY_CLASSES = ['overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-desktop'];

  /* ── state ── */
  function tabEl(name) {
    return details && details.querySelector('[data-hk-tab-btn="' + name + '"]');
  }
  // UX-049: on phones/tablets the section title stands in for the tabs; the tab is the fallback (tabs still shown)
  function focusTarget(name) {
    var title = details && details.querySelector('.hk-mdrawer-title');
    return title && title.getClientRects().length ? title : tabEl(name);
  }
  // Dawn's sub-lists (<details> inside the drawer), deepest first
  function closeSubmenus() {
    if (!details || !drawer || typeof drawer.closeSubmenu !== 'function') return false;
    var open = Array.prototype.slice.call(details.querySelectorAll('#menu-drawer details[open]')).reverse();
    open.forEach(function (d) { drawer.closeSubmenu(d); });
    return open.length > 0;
  }
  function activeTab() {
    var t = details && details.querySelector('[data-hk-tab-btn][aria-selected="true"]');
    return t ? t.getAttribute('data-hk-tab-btn') : 'catalog';
  }
  // Dawn adds .menu-opening one tick after the open attribute and removes it at once on close (the attribute
  // itself stays until the closing animation ends)
  function drawerOpen() {
    return !!details && details.hasAttribute('open') && details.classList.contains('menu-opening');
  }
  function drawerClosing() {
    return !!details && details.hasAttribute('open') && !details.classList.contains('menu-opening');
  }
  function overlayOpen() {
    var cl = document.body.classList;
    return OVERLAY_CLASSES.some(function (c) { return cl.contains(c); });
  }
  function setExpanded(el, value) {
    if (el && el.hasAttribute('aria-expanded')) el.setAttribute('aria-expanded', value ? 'true' : 'false');
  }

  function sync() {
    var open = drawerOpen();
    var tab = activeTab();
    setExpanded(items.catalog, open && tab === 'catalog');
    setExpanded(items.extra, open && tab === 'extra');
    setExpanded(items.contact, sheetOpen);
    bar.classList.toggle('is-raised', open || sheetOpen);
    bar.classList.toggle('is-hidden', !open && !sheetOpen && (typing || overlayOpen()));
  }

  /* ── drawer ── */
  function selectTab(name) {
    var t = tabEl(name);
    // the tab's own click handler (header-drawer.liquid) switches the panels and the roving tabindex
    if (t && t.getAttribute('aria-selected') !== 'true') t.click();
  }

  function openDrawer(name, item) {
    closeSheet(false);
    // a sub-list left open in the other section would greet the visitor on the way back
    if (activeTab() !== name) closeSubmenus();
    selectTab(name);
    opener = item;
    if (drawerOpen()) {
      focusWhenShown(focusTarget(name), 0);
      sync();
      return;
    }
    if (drawerClosing()) {
      details.addEventListener('toggle', function () { openDrawer(name, item); }, { once: true });
      return;
    }
    summary.click();
    focusWhenShown(focusTarget(name), 0);
    sync();
  }

  // Dawn focuses its (hidden) toggle; the section title (or the active tab) is the first useful stop. The drawer is still
  // visibility: hidden on the frame it opens, so wait until the tab can take focus.
  function focusWhenShown(el, tries) {
    if (!el || tries > 30 || !details.hasAttribute('open')) return;
    el.focus({ preventScroll: true });
    if (document.activeElement !== el) requestAnimationFrame(function () { focusWhenShown(el, tries + 1); });
  }

  function closeDrawer(event) {
    if (!drawer || typeof drawer.closeMenuDrawer !== 'function') return;
    drawer.closeMenuDrawer(event, summary);
    summary.setAttribute('aria-expanded', 'false');
    if (opener) opener.focus({ preventScroll: true });
    sync();
  }

  /* ── contact sheet ── */
  function status() {
    try {
      return window.HKTopbar && window.HKTopbar.status ? window.HKTopbar.status() : null;
    } catch (e) {
      return null;
    }
  }

  function fillStatus() {
    var st = status();
    var open = !!st && (st.state === 'open' || st.state === 'soon');
    if (dot) dot.hidden = !open;
    if (dotText) dotText.hidden = !open;
    if (!hours) return;
    try {
      if (!st || !st.today) return;
      var line = hours.getAttribute('data-template').replace('[hours]', st.today);
      // same wording as the drawer's hours line (header-drawer.liquid)
      if (st.label) line = st.label.indexOf(st.today) === 0 ? st.label : line + ' · ' + st.label;
      hours.textContent = line;
      hours.setAttribute('data-status', st.state);
      hours.hidden = false;
    } catch (e) { /* the hours line is extra; never block the sheet */ }
  }

  function focusables() {
    return Array.prototype.filter.call(panel.querySelectorAll('a[href], button'), function (el) {
      return el.getClientRects().length > 0;
    });
  }

  function onSheetKey(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeSheet(true);
      return;
    }
    if (event.key !== 'Tab') return;
    var list = focusables();
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {
      event.preventDefault();
      first.focus();
    }
  }

  function openSheet() {
    if (!sheet || sheetOpen) return;
    if (drawerOpen()) closeDrawer(new Event('click'));
    fillStatus();
    sheetOpen = true;
    sheet.hidden = false;
    sheet.offsetHeight; // start the slide-up from the closed position
    sheet.classList.add('is-open');
    // a body class with "overflow-hidden" in its name: hk-chat-guard.js hides the chat launcher while it is set
    document.body.classList.add('overflow-hidden-hk-bnav');
    document.addEventListener('keydown', onSheetKey, true);
    var first = focusables()[0];
    if (first) first.focus({ preventScroll: true });
    sync();
  }

  function closeSheet(restoreFocus) {
    if (!sheet || !sheetOpen) return;
    sheetOpen = false;
    sheet.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden-hk-bnav');
    document.removeEventListener('keydown', onSheetKey, true);
    setTimeout(function () { if (!sheetOpen) sheet.hidden = true; }, reduceMotion.matches ? 0 : 230);
    if (restoreFocus && items.contact) items.contact.focus({ preventScroll: true });
    sync();
  }

  /* ── wiring ── */
  function onItem(event) {
    if (!mq.matches) return;
    var item = event.currentTarget;
    var kind = item.getAttribute('data-hk-bnav-item');
    if (kind === 'contact') {
      if (!sheet) return; // plain tel: link
      event.preventDefault();
      sheetOpen ? closeSheet(true) : openSheet();
      return;
    }
    if (!summary) return; // no drawer on this page: Catalog stays a link to the collections list
    event.preventDefault();
    // Dawn's closeSubmenu puts focus back on the row the sub-list opened from
    if (drawerOpen() && activeTab() === kind) {
      if (!closeSubmenus()) closeDrawer(event);
    } else openDrawer(kind, item);
  }

  Object.keys(items).forEach(function (kind) {
    var el = items[kind];
    // links that now open a panel instead of navigating behave as buttons
    if (el.tagName === 'A' && ((kind === 'contact' && sheet) || (kind === 'catalog' && summary))) {
      el.setAttribute('role', 'button');
      el.setAttribute('aria-expanded', 'false');
      el.addEventListener('keydown', function (event) {
        if (event.key !== ' ' && event.key !== 'Spacebar') return;
        event.preventDefault();
        el.click();
      });
    }
    el.addEventListener('click', onItem);
  });
  if (!summary && items.extra) items.extra.hidden = true;

  if (sheet) {
    sheet.addEventListener('click', function (event) {
      if (event.target.closest('[data-hk-bnav-close]')) {
        closeSheet(true);
        return;
      }
      var a = event.target.closest('[data-hk-bnav-channel]');
      if (!a) return;
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'hk_contact_click', hk_form: 'bottom_nav', hk_channel: a.getAttribute('data-hk-bnav-channel') });
      } catch (err) {}
    });
  }

  if (details) {
    // the hidden toggle is no tab stop while the bar stands in for it
    var syncToggle = function () {
      if (mq.matches) summary.setAttribute('tabindex', '-1');
      else summary.removeAttribute('tabindex');
    };
    syncToggle();
    mq.addEventListener('change', syncToggle);

    details.addEventListener('toggle', function () {
      // closed from inside (X, overlay, Esc): Dawn returns focus to its hidden toggle, so hand it to the bar item
      if (!details.open && opener && mq.matches) {
        var active = document.activeElement;
        if (!active || active === summary || active === document.body) opener.focus({ preventScroll: true });
      }
      sync();
    });
    new MutationObserver(sync).observe(details, { attributes: true, attributeFilter: ['open', 'class'] });
    var tabs = details.querySelector('[role="tablist"]');
    if (tabs) new MutationObserver(sync).observe(tabs, { subtree: true, attributes: true, attributeFilter: ['aria-selected'] });
  }

  new MutationObserver(sync).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  var TEXT_TYPES = /^(text|search|email|tel|number|url|password|date|datetime-local|month|time|week)$/;
  function isTextField(el) {
    if (!el || el === document.body) return false;
    if (el.isContentEditable) return true;
    if (el.tagName === 'TEXTAREA' || el.tagName === 'SELECT') return true;
    return el.tagName === 'INPUT' && TEXT_TYPES.test(el.type || 'text');
  }
  function updateTyping() {
    var value = isTextField(document.activeElement);
    if (value === typing) return;
    typing = value;
    sync();
  }
  document.addEventListener('focusin', updateTyping);
  document.addEventListener('focusout', function () { setTimeout(updateTyping, 0); });

  mq.addEventListener('change', function () {
    if (!mq.matches) closeSheet(false);
  });
  window.addEventListener('pageshow', function () {
    closeSheet(false);
    fillStatus();
    sync();
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') fillStatus();
  });
  // hk-topbar.js may run after this file; the dot waits for it
  if (document.readyState === 'complete') fillStatus();
  else window.addEventListener('load', fillStatus);
  fillStatus();
  sync();
})();
